module.exports = {
  "meetingsLibLoaded": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": [
        "public",
        "public:embedded"
      ]
    }
  },
  "meetingsLibViewScreen": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": [
        "public",
        "public:embedded"
      ],
      "subscreen": "string"
    }
  },
  "meetingsLibClickPromoLink": {
    "name": "click viral link",
    "class": "interaction",
    "properties": {
      "page": "string"
    }
  },
  "meetingsLibSetProperty": {
    "name": "Set meeting property",
    "class": "interaction",
    "properties": {
      "property": "string",
      "value": "string"
    }
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/events.yaml
// module id = 423
// module chunks = 0